import React from 'react';
import styles from '../styles';

const ConditionsDropDown = (props) => {
  console.log(props, "PROPS")
  return (<div style={styles.container}>
    {(props.data && props.data.terms) && props.data.terms.map(term => <p>{term.name1}</p>)}
  </div>)
}

export default  ConditionsDropDown;
